import firebase from 'firebase/compat/app';

import 'firebase/compat/firestore';

import firebaseConfig from './firebaseConfig';

/**
 * Initialize Firebase
 */
export const firebaseApp = firebase.initializeApp(firebaseConfig);

export const firestoreDB = firebaseApp.firestore();
